<template>
  <div class="line">
    <div class="con">
      <div class="bau">
        <img src="../../../assets/img/SSGJ/bau.png" alt />
      </div>
      <div class="libox">
        <div class="li" v-for="(item, index) in List" :key="index">
          <div class="wz">
            <p>{{ item.name }}</p>
            <p v-if="index % 2 != 1">
              <span></span>
              <span>{{ item.value }}</span>
            </p>
            <p v-else>
              <span></span>
              <span>{{ item.value }}</span>
            </p>
          </div>
          <div class="btn">
            <p
              v-for="(val, ind) in item.btn"
              :key="ind"
              :class="index.toString() + ind == SBDKPXindex ? 'ac' : ''"
              @click="SBDKPXPoint(ind, index, item, val)"
            >
              {{ val }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UEapi from '@/utils/UEapi/UEapi'
import cameraList from '@/utils/configs/cameraList'
import ObjectManager from '@/utils/control/ObjectManager'
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    List: {
      type: Array,
      default: () => {
        return [
          {
            name: 'Server-b22',
            value: 'SQL-1',
            id: 'C03-004-04_SM_服务器',
            port: 'API_C0300404_服务器_背_F02',
            btn: ['设 备', '端 口'],
          },
          {
            name: 'SQL数据库服务_port_SQL-1_D04_ODF1_port_OP-2',
            value: 'OP-2',
            id: 'Link_SM_机柜通讯线C03',
            btn: ['配 线'],
          },
          {
            name: 'Server-b23',
            id: 'C03-004-04_SM_配线架',
            value: 'OP-3',
            port: 'API_C0300404_配线架_正_A40',
            btn: ['设 备', '端 口'],
          },
          {
            name: 'D04-ODF1_port_OPB-2_F03_ODF1_port_OP-4',
            id: 'Link_SM_机柜通讯线CF01', //Link_SM_机柜通讯线CF02
            value: 'OP-4',
            btn: ['配 线'],
          },
          {
            name: 'F03-ODF1',
            id: 'F06-004-04_SM_配线架',
            value: 'OP-5',
            port: 'API_F0600407_配线架_正_A31',
            btn: ['设 备', '端 口'],
          },
          {
            name: 'D04-ODF1_port_OPB-4_F03_BANKA_01_port_OP-3',
            value: 'OP-6',
            id: 'Link_SM_机柜通讯线F06',
            btn: ['配 线'],
          },
          {
            name: 'F03-ODF1',
            value: 'OP-5',
            id: 'F06-004-04_SM_大型服务器',
            port: 'API_F0600407_大型服务器_背_A01',
            btn: ['设 备', '端 口'],
          },
          // {
          //   name: 'D04-ODF1_port_OPB-4_F03_BANKA_01_port_OP-3',
          //   value: 'OP-6',
          //   id: 'Link_SM_机柜通讯线CA',
          //   btn: ['配 线'],
          // },
        ]
      },
    },
    closeCabinetDoor: {
      type: Boolean,
      default: '',
    },
  },
  data() {
    return {
      SBDKPXindex: -1,
      ports: '',
      isOpenCabinetDoor: false,
    }
  },
  watch: {
    closeCabinetDoor: {
      handler(val) {
        this.isOpenCabinetDoor = val
      },
      deep: true,
    },
  },
  methods: {
    setModelStyle(params) {
      window.appInstance.uniCall('setModelStyle', params, (res) => {
        console.log('设置模型样式', params, res)
        if (params.maskType == 'none') {
          this.ports = ''
        }
      })
    },

    SBDKPXPoint(i, maxIndex, item, val) {
      console.log(item, val)
      if (this.SBDKPXindex == maxIndex.toString() + i) {
        this.SBDKPXindex = -1
        this.$emit('changeSBDKPXPoint', '')
      } else {
        this.SBDKPXindex = maxIndex.toString() + i
        this.$emit('changeSBDKPXPoint', this.title)
      }

      if (val == '设 备') {
        this.ports &&
          this.setModelStyle({
            id: this.ports,
            maskType: 'none',
          })
        window.layerConfig.modelOnlyHighlight(item.id)
        UEapi.Camera.setCamera(cameraList[item.id])
        if (
          (item.id == 'F06-004-04_SM_配线架' ||
            item.id == 'F06-004-04_SM_大型服务器') &&
          !this.isOpenCabinetDoor
        ) {
          this.isOpenCabinetDoor = true
          UEapi.Model.playAnimation({
            id: 'F06-004-07_SM_设备机柜',
            name: '机柜_前_开',
            state: 'begin',
          })
          UEapi.Model.playAnimation({
            id: 'F06-004-07_SM_设备机柜',
            name: '机柜_后_开',
            state: 'begin',
          })
        }

        if (
          (item.id == 'A01-004-04_SM_配线架' ||
            item.id == 'A01-004-04_SM_服务器') &&
          !this.isOpenCabinetDoor
        ) {
          this.isOpenCabinetDoor = true
          UEapi.Model.playAnimation({
            id: 'A01-004-04_SM_机柜组',
            name: '机柜_前_开',
            state: 'begin',
          })
          UEapi.Model.playAnimation({
            id: 'A01-004-04_SM_机柜组',
            name: '机柜_后_开',
            state: 'begin',
          })
        }
      }

      if (val == '端 口') {
        this.ports = item.port
        let jsonData = {
          id: item.port,
          maskType: 'color',
          maskAlpha: 1,
          maskColor: '#ff0000',
        }
        this.setModelStyle(jsonData)
        cameraList[item.port] && UEapi.Camera.setCamera(cameraList[item.port])
      }

      if (val == '配 线') {
        this.ports &&
          this.setModelStyle({
            id: this.ports,
            maskType: 'none',
          })
        if (cameraList[item.id]) {
          UEapi.Camera.setCamera(cameraList[item.id])
        } else {
          UEapi.Model.focusModel({
            id: item.id,
            modelType: 'model',
            distance: 1.5,
          })
        }
      }
    },
  },
  mounted() {},
}
</script>

<style lang="less" scoped>
.line {
  margin-left: -50px;
  width: 676px;
  height: 1004px;
  background: rgba(24, 155, 250, 0.1);
  .con {
    display: flex;
    width: 576px;
    margin: 0 auto;
    justify-content: space-between;
    align-items: center;
    .bau {
      margin-top: 58px;
    }
    .btn {
      width: 110px;
      // margin-top: 40px;
      p {
        pointer-events: all;
        margin-bottom: 12px;
        width: 110px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: url('../../../assets/img/SSGJ/btn.png') no-repeat;
        font-size: 26px;
        font-family: '微软雅黑';
        color: #ccc;
      }
      // p:nth-child(2),
      // p:nth-child(3),
      // p:nth-child(5),
      // p:nth-child(6),
      // p:nth-child(8),
      // p:nth-child(9) {
      //   margin-bottom: 52px;
      // }
      .ac {
        margin-bottom: 12px;
        width: 110px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: url('../../../assets/img/SSGJ/btnac.png') no-repeat;
        font-size: 26px;
        font-family: '微软雅黑';
        color: #ccc;
      }
    }
    .libox {
      height: 902px;
      overflow-y: auto;
      overflow-x: hidden;
    }
    ::-webkit-scrollbar {
      width: 0px;
      border-radius: 0px;
      background: rgba(17, 63, 89, 0.65);
    }
    ::-webkit-scrollbar-thumb {
      width: 0px;
      border-radius: 0px;
      background: rgba(255, 255, 255, 0.15);
      min-height: 00px;
    }
    .li {
      margin-bottom: 16px;
      width: 500px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid rgba(255, 255, 255, 0.3);
      .wz {
        width: 390px;
        p:nth-child(1) {
          font-size: 26px;
          font-family: '微软雅黑';
          color: #fff;
        }
        p:nth-child(2) {
          display: flex;
          align-items: center;
          span:nth-child(1) {
            width: 10px;
            height: 10px;
            background: #55b7ff;
            border-radius: 50%;
            margin-right: 10px;
          }
          span:nth-child(2) {
            font-size: 26px;
            font-family: '微软雅黑';
            color: #fff;
          }
        }
      }
    }
    .li:nth-child(odd) {
      height: 136px;
    }
    .li:nth-child(even) {
      height: 110px;
      width: 500px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid rgba(255, 255, 255, 0.3);
      .wz {
        width: 390px;
        p:nth-child(1) {
          font-size: 26px;
          font-family: '微软雅黑';
          color: #52f2ff;
        }
        p:nth-child(2) {
          display: none;
          align-items: center;
          span:nth-child(1) {
            width: 10px;
            height: 10px;
            background: #55b7ff;
            border-radius: 50%;
          }
          span:nth-child(2) {
            font-size: 26px;
            font-family: '微软雅黑';
            color: #fff;
          }
        }
      }
    }
  }
}
</style>